import { render } from "./HeaderPalantir.vue?vue&type=template&id=6f971e20&scoped=true"
import script from "./HeaderPalantir.vue?vue&type=script&lang=js"
export * from "./HeaderPalantir.vue?vue&type=script&lang=js"

import "./HeaderPalantir.vue?vue&type=style&index=0&id=6f971e20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f971e20"]])

export default __exports__